import GroupList from "./groupList";
import StandingsTableComplete from "./standingsTableComplete";
import "./groupsPanel.sass";

export default function GroupsPanel({ TABS, activeGroup, onSelect, groupsState }) {
  return (
    <div className="GroupsPanel">
      <div className="listStandings">
        <GroupList
          groups={TABS}
          activeGroup={activeGroup}
          onSelect={onSelect}
          groupsState={groupsState}
        />

        <StandingsTableComplete
          TABS={TABS}
          groupsState={groupsState}
          activeGroup={activeGroup}
          onSelect={onSelect}
        />
      </div>
    </div>
  );
}